import React from 'react';
import { useReportGenerator } from '../../hooks/useReportGenerator';
import './ReportButton.css';

interface ReportButtonProps {
  userId: string;
  jwtToken: string;
  facilityId: number;
  websocketUrl: string;
}

export function ReportButton({ userId, jwtToken, facilityId, websocketUrl }: ReportButtonProps) {
  const {
    isGenerating,
    progress,
    message,
    error,
    generateReport,
    cancelReport,
  } = useReportGenerator({ userId, jwtToken, websocketUrl });

  const handleClick = () => {
    if (isGenerating) {
      cancelReport();
    } else {
      generateReport({
        template_uuid: 'rpt_tpl_001',
        facility_id: facilityId,
        runtime_params: { facility_id: facilityId },
      });
    }
  };

  return (
    <div className="report-button-container">
      <button
        onClick={handleClick}
        className={`report-button ${isGenerating ? 'cancel' : 'generate'}`}
        disabled={!!error}
      >
        {isGenerating ? 'Cancel Report' : 'Generate Report'}
      </button>

      {isGenerating && (
        <div className="progress-container">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="progress-message">{message} ({progress}%)</p>
        </div>
      )}

      {error && (
        <div className="error-message">
          <p>❌ {error}</p>
        </div>
      )}
    </div>
  );
}
